import { render, staticRenderFns } from "./successNoticeModal.vue?vue&type=template&id=6a460324&scoped=true"
import script from "./successNoticeModal.vue?vue&type=script&lang=js"
export * from "./successNoticeModal.vue?vue&type=script&lang=js"
import style0 from "./successNoticeModal.vue?vue&type=style&index=0&id=6a460324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a460324",
  null
  
)

export default component.exports